<template>
  <datatable
    v-if="gridData.length > 0"
    :filter="search"
    :flat="true"
    :data="gridData"
    :columns="columns"
    @rowDoubleClick="handleDoubleClick"
  >
    <template slot="body-cell-association_abbr" slot-scope="data">
      <q-td :props="data.props">
        <q-img
          v-if="data.props.row.capUrl"
          :src="data.props.row.capUrl"
          width="40px"
          contain
          class="q-ml-sm"
        >
        </q-img>
        {{ data.props.row.association_abbr }}
      </q-td>
    </template>
  </datatable>
</template>

<script>
  import datatable from "@/components/datatable/datatable.vue";

  export default {
    props: {
      gridData: [],
      search: {
        default: "",
        type: String,
      },
    },
    components: {
      datatable,
    },
    data() {
      return {
        columns: [
          {
            name: "association_abbr",
            label: "CLUB",
            align: "left",
            field: "association_abbr",
            sortable: true,
          },
          {
            name: "points",
            label: "Points",
            align: "right",
            field: "points",
            format: (val) => (val ? val : 0),
            style:
              "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
            sortable: true,
          },
        ],
      };
    },
    methods: {
      handleDoubleClick(row) {
        console.log(row);
      },
    },
  };
</script>

<style>
</style>template
